(ns common.db.effects.json
  (:require [goog.dom :as gdom]
            [re-frame.core :as rf]))

(defn download-json
  [json name]
  (let [uri (str "data:text/json;charset=utf-8,"
                 (js/encodeURIComponent json))
        tag (gdom/createElement "a")
        filename (str (or name "download") ".json")
        props {:href uri :download filename}]
    (gdom/setProperties tag (clj->js props))
    (.click tag)))

(rf/reg-fx :json/download
  (fn [[json name]]
    (download-json json name)))
